// FILE: src/components/chatwoot/ChatwootWidget.tsx
// VERSION: 1.0.0
// START_MODULE_CONTRACT:
// PURPOSE: Vidzhet podderzhki Chatwoot (self-hosted) dlya vneshki i CRM — faza 8 REVIVE.
//   Vklyuchaetsya TOLKO pri zadannykh NEXT_PUBLIC_CHATWOOT_BASE_URL i NEXT_PUBLIC_CHATWOOT_WEBSITE_TOKEN
//   (inache renderit null — bezopasno do deplya Chatwoot-servera).
// SCOPE: script-inektsiya Chatwoot, inicializatsiya vidzheta, pustoy render pri otsutstvii konfiguratsii.
// INPUT: env NEXT_PUBLIC_CHATWOOT_BASE_URL, NEXT_PUBLIC_CHATWOOT_WEBSITE_TOKEN.
// OUTPUT: <script> Chatwoot SDK + window.chatwootSettings.
// KEYWORDS: TECH(NextJS): ClientComponent; DOMAIN(Support): Chatwoot; DOMAIN(SEO): PublicPages
// END_MODULE_CONTRACT
//
// START_CHANGE_SUMMARY:
// LAST_CHANGE: 1.0.1 — launcherTitle исправлен на русский «Поддержка OXPA»; env задаются в CI (deploy.yml).
// END_CHANGE_SUMMARY
"use client";

import { useEffect } from "react";

declare global {
  interface Window {
    chatwootSettings?: { position: "right"; type: "standard"; launcherTitle: string; locale: "ru" };
  }
}

export function ChatwootWidget() {
  const baseUrl = process.env.NEXT_PUBLIC_CHATWOOT_BASE_URL;
  const websiteToken = process.env.NEXT_PUBLIC_CHATWOOT_WEBSITE_TOKEN;

  useEffect(() => {
    if (!baseUrl || !websiteToken) return; // Chatwoot ne skonfigurirovan — vidzhet ne gruzim

    window.chatwootSettings = {
      position: "right",
      type: "standard",
      launcherTitle: "Поддержка OXPA", // UI: только русский (AGENTS.md правило 1)
      locale: "ru",
    };

    const script = document.createElement("script");
    script.src = baseUrl + "/packs/js/sdk.js";
    script.defer = true;
    script.async = true;
    script.onload = () => {
      try {
        const sdk = (window as any).chatwootSDK;
        if (sdk && typeof sdk.run === 'function') {
          sdk.run({ websiteToken, baseUrl });
        }
      } catch (err) {
        console.error("[Chatwoot] init failed:", err);
      }
    };
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [baseUrl, websiteToken]);

  return null;
}
